var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPaid48Filled = function SvgIconPaid48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.3A15.7 15.7 0 1 0 39.7 24 15.71 15.71 0 0 0 24 8.3Zm1.54 21.9h-.12v1.3h-2.76v-1.27h-.12a4 4 0 0 1-3.47-4.06h3.52A1.26 1.26 0 0 0 24 27.35c.66 0 1.36-.33 1.36-1 0-.67-.9-1-2-1.24h-.06c-1.8-.44-4-1-4-3.78a3.57 3.57 0 0 1 3.19-3.62h.12V16.5h2.69v1.21h.12a3.67 3.67 0 0 1 3.11 3.79h-3.41c0-.77-.68-1-1.26-1s-1.17.23-1.17.76.91.91 2 1.2h.05c1.75.45 4.14 1.07 4.14 3.86a3.82 3.82 0 0 1-3.34 3.88Z",
    fill: "current"
  })));
};
export default SvgIconPaid48Filled;